import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=595301ba&"
import script from "./refuse.vue?vue&type=script&lang=js&"
export * from "./refuse.vue?vue&type=script&lang=js&"
import style0 from "./refuse.vue?vue&type=style&index=0&id=595301ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports